import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import RoutinePopup from "../Reusable/Routine/Popup/RoutinePopup";

import {

  Box,
  Typography,


} from "@mui/material";
import GlobalPoliciesPopup from "../Reusable/Routine/Popup/GlobalPoliciesPopup";

import SectionSlider from "../Reusable/SectionSlider/SectionSlider";
import { sections, sectionPaths } from '../../constants/sectionData';
import ActivityBar from "../Reusable/ActivityBar/ActivityBar";

import GlobalPoliciesFileViewPopup from '../Reusable/Popup/PPIFileViewPopup'
import GPAdminFileViewPopup from '../Reusable/Popup/PPIadminFileViewPopup'
import { apiService } from "../../api/apiService";
import RoutineTabs from "../Reusable/utils/RoutineTabsPPI";
import FBSPopup from "../Reusable/Routine/Popup/FBSPopup";
import PPIPopup from "../Reusable/Routine/Popup/PPIPopup";
import { getFileImagePath } from '../Reusable/utils/fileUtils'; // Import the utility function


interface LocationState {
  management?: string;
  id: any;
  function_l1: any;
  file_name: string;
  created_at: any;
  updated_at:any;
  updated_by:any;
  onClick: (id: any, file_name: string, function_l1: any, created_at: any, updated_at:any, updated_by:any ) => void;
  status: any;
  reason_to_approve: any;
  reason_to_revert: any;
}
interface GlobalPoliciesUploadProps {

  isAdmin?: boolean;
  isManager?: boolean;


}

interface FilterValues {
  function_l1: string;
  function_l2: string;
  function_l3: string;
  function_l4: string;
}

const verticalTabs = [
  { label: "Product and Process Indicators", value: "a" },
];

const PPI: React.FC<GlobalPoliciesUploadProps> = ({ isAdmin, isManager }) => {
  const { instance } = useMsal();
  
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState("1");
  const [verticalTabValue, setVerticalTabValue] = useState("a");
  const [openUpload, setOpenUpload] = useState(false);
  const [open, setOpen] = useState(false);
  const [routineData, setRoutineData] = useState<any[]>([]);



  // const locationState = location.state as LocationState | undefined;
  // const management = locationState?.management || "Default Location Name";
  const management = localStorage.getItem("management") || "Default Location Name";
  const [currentPage, setCurrentPage] = useState(1);
  const [filterValue, setFilterValue] = useState('');
  const [files, setFiles] = useState<LocationState[]>([]);


  const [isPopupOpen, setPopupOpen] = useState(false);

  const [page, setPage] = useState(1);
  const itemsPerPage = 3;
  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  // const paginatedData = routineData.slice(startIndex, endIndex);

  // Tab Status Logic
  const tabStatuses: { label: string; value: 'All' | 'Pending' | 'Approved' | 'Reverted'; apiStatus: string | null }[] = [
    { label: 'All', value: 'All', apiStatus: null }, // `null` means no filtering (include all statuses)
    { label: 'Pending', value: 'Pending', apiStatus: 'Pending' },
    { label: 'Approved', value: 'Approved', apiStatus: 'Approved' },
    { label: 'Reverted', value: 'Reverted', apiStatus: 'Reverted' },
  ];
  const selectedStatus = tabStatuses.find(tab => String(tabStatuses.indexOf(tab) + 1) === tabValue)?.value;

  // Filter routineData based on the selected tab status
  const filteredRoutineData = selectedStatus === "All"
    ? routineData
    : routineData.filter(item => item.status === selectedStatus);

  const paginatedData = filteredRoutineData.slice(startIndex, endIndex);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClosePopup = () => {
    setPopupOpen(false);
  };




  
  // const handleApplyFilter = (function_l1: string, function_l2: string, function_l3: string, function_l4:string) => {
  //   setFunctionL1(function_l1);
  //   setFunctionL2(function_l2);
  //   setFunctionL3(function_l3);
  //   setFunctionL4(function_l4);
  //   fetchRoutineData(function_l1, function_l2, function_l3, function_l4); // Fetch data with filters
  // };

    const [filterValues, setFilterValues] = useState<FilterValues>({
      function_l1: '',
      function_l2: '',
      function_l3: '',
      function_l4: ''
    });
    

  // Update handleApplyFilter to handle all levels

const handleApplyFilter = (function_l1: string, function_l2: string, function_l3: string, function_l4: string) => {
  const newFilters = {
    function_l1,
    function_l2,
    function_l3,
    function_l4
  };
  setFilterValues(newFilters);
  setPage(1);
  fetchRoutineData(newFilters);
};





  const fetchRoutineData = async (filters: Partial<FilterValues> = {}) => {
    setIsLoading(true);
    try {
      const response = await apiService(
        "/management/filter_product_process_indicator",
        "GET",
        {
          management: management,
          // section_name: verticalTabs.find((tab) => tab.value === verticalTabValue)?.label,
          ...filters

        },
        undefined,
        instance as PublicClientApplication
      );

      if (response.data) {
        setRoutineData(response.data); // Update routineData
        setFiles(response.data); // Sync files with the API response
      }
    } catch (error) {
      console.error("Error fetching routine data:", error);

      // Set routineData to null on API failure
      setRoutineData([]);

      // Update the error state
      if (error instanceof Error) {
        setError(error.message || "An error occurred");
      } else {
        setError("An error occurred");
      }

      // Check if the error status is 401 and redirect to /login
      if (error instanceof Error && (error as any).response && (error as any).response.status === 401) {
        navigate('/login');
      }
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {

    fetchRoutineData();
  }, [verticalTabValue]);


  // const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
  //   setTabValue(newValue);
  // };

  const handleVerticalTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setVerticalTabValue(newValue);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [selectedFile, setSelectedFile] = useState<{ id:any, function_l1:any, function_l2:any, function_l3:any, function_l4:any, management:any, section_name:any, doc_path:any, file_size:any, file_name:any, status:any, manager_id:any, created_by:any, updated_by:any, updated_by_email:any, approver_id:any, created_at:any, updated_at:any, reason_to_approve:any, reason_to_reject:any, reason_to_revert:any } | null>(null);
  console.log('selectedFile selectedFile', selectedFile);



  // const handleViewClick = (id: any, file_name: string, function_l1: any, created_at: any, updated_at:any, updated_by:any, status: any, reason_to_approve: any, reason_to_revert: any) => {
  //   setPopupOpen(true);
  //   setSelectedFile({ id, file_name, function_l1, created_at, status, reason_to_approve, reason_to_revert, updated_at, updated_by });
  // };

    const handleViewClick = (
      id: any,
      function_l1: any,
      function_l2: any,
      function_l3: any,
      function_l4: any,
      created_at: any,
      updated_at: any,
      updated_by: any,
      management: any,
      section_name: any,
      doc_path: any,
      file_size: any,
      file_name: any,
      status: any,
      manager_id: any,
      created_by: any,
      updated_by_email: any,
      approver_id: any,
      reason_to_approve: any,
      reason_to_reject: any,
      reason_to_revert: any
      
    ) => {
      setPopupOpen(true);
      setSelectedFile({
        id,
        function_l1,
        function_l2,
        function_l3,
        function_l4,
        created_at,
        updated_at,
        updated_by,
        management,
        section_name,
        doc_path,
        file_size,
        file_name,
        status,
        manager_id,
        created_by,
        updated_by_email,
        approver_id,
        reason_to_approve,
        reason_to_reject,
        reason_to_revert

       
      });
    };




  const breadcrumbs = [
   <Link key="1" to="/">
         Home
       </Link>,
       <Link key="2" to="/operations/management">
         Evidence Upload
       </Link>,
         <Link key="3" color="#000" to="/operations/management">
                Management
              </Link>,
    <Typography key="4" sx={{ fontFamily: 'Avantt' }}>
      {management}
    </Typography>,
  ];


  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    console.log("Tab changed to:", newValue);
    setTabValue(newValue);
  };



  const counts = {
    All: files.length,
    Pending: files.filter((file) => file.status === 'Pending').length,
    Approved: files.filter((file) => file.status === 'Approved').length,
    Reverted: files.filter((file) => file.status === 'Reverted').length,
  };

 

  return (
    <>
      {/* Activity Bar and Section Slider */}
      <ActivityBar breadcrumbs={breadcrumbs} />
      <SectionSlider
        sections={sections}
        sectionPaths={sectionPaths}
        highlightSection={'Product and Process Indicators'}
        highlightColor="#D7A833"
        defaultColor="#666"
      />

      {/* <Box className="tabs_routine">  */}
      <RoutineTabs
        tabValue={tabValue}
        handleTabChange={handleTabChange}
        tabStatuses={tabStatuses}
        counts={counts}
        verticalTabValue={verticalTabValue}
        question="Question : Process KPI's defined and included in the corresponding MCRS, actions plans are in place for low-performing KPIs"
        fileUploadText="Provide a KPI tree diagram or report showing how critical services from the Business Description are mapped to corresponding KPIs. Evidence should demonstrate tracking of these KPIs and their improvement."

        verticalTabs={verticalTabs}
        isLoading={isLoading}
        filteredRoutineData={filteredRoutineData}
        paginatedData={paginatedData}
        routineData={routineData}
        itemsPerPage={itemsPerPage}
        handleChangePage={handleChangePage}
        handleViewClick={handleViewClick}
        setOpenUpload={setOpenUpload}
        getFileImagePath={getFileImagePath}
        handleVerticalTabChange={handleVerticalTabChange}
        handleApplyFilter={handleApplyFilter}
        level4={true}
      //  functionL1={functionL1}
       initialValues={{
        l1: filterValues.function_l1,
        l2: filterValues.function_l2,
        l3: filterValues.function_l3,
        l4: filterValues.function_l4
      }}
      functionL1={filterValues.function_l1}
      functionL2={filterValues.function_l2}
      functionL3={filterValues.function_l3}
      functionL4={filterValues.function_l4}
      reuploadapiEndpoint="/management/product_process_indicator"
      onSuccess={fetchRoutineData}



      // isMcrTab={true}
      />


      {/* Upload form section */}

      <PPIPopup openUpload={openUpload} setOpenUpload={setOpenUpload} management={management} verticalTabValue={verticalTabs.find(tab => tab.value === verticalTabValue)?.label} onSuccess={fetchRoutineData} />
      {/* File View Popup */}
      {isPopupOpen && selectedFile && (
        <>
          {
            isManager && (
              <GlobalPoliciesFileViewPopup
                onClose={handleClosePopup}
                open={true}
                name={selectedFile.file_name}
                id={selectedFile.id}
                functionl1={selectedFile.function_l1}
                functionl2={selectedFile.function_l2}
                functionl3={selectedFile.function_l3}
                functionl4={selectedFile.function_l4}
                date={selectedFile.updated_at}
                updatedBy={selectedFile.updated_by}
                sectionTitle="Product and Process Indicators"
                userDetail={true}
                apiPath={`/management/product_process_indicator/${selectedFile.id}`} // Pass the API path for file details

              />
            )
          }


          {isAdmin && (
            <GPAdminFileViewPopup
              onClose={handleClosePopup}
              open={true}
              name={selectedFile.file_name}
              id={selectedFile.id}
              functionl1={selectedFile.function_l1}
               functionl2={selectedFile.function_l2}
                functionl3={selectedFile.function_l3}
                functionl4={selectedFile.function_l4}
              date={selectedFile.created_at}
              updatedBy={selectedFile.updated_by}
              status={selectedFile.status}
              reason_to_approve={selectedFile.reason_to_approve}
              reason_to_revert={selectedFile.reason_to_revert}
              sectionTitle="Product and Process Indicators"
              apiPath={`/management/product_process_indicator/${selectedFile.id}`} // Pass the API path for file details
              statusApiPath="/management/product_process_indicator_status" // Pass the API path for status updates
              onSuccess={fetchRoutineData} // Add this line

            />
          )}
        </>
      )}

    </>
  );
};

export default PPI;